<template>
  <div>
    <CustomPageHeaderVue class="flex-grow-0">{{
      $t("orderlist_title")
    }}</CustomPageHeaderVue>
    <CustomRow>
      <v-card
        class="mt-5 bg-transparent"
        :min-height="contentHeight"
        :elevation="!($vuetify.breakpoint.xs || $vuetify.breakpoint.sm) ? 8 : 0"
        :class="{
          'cusPadding white': !(
            $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
          )
        }"
      >
        <template v-if="loadingFinished">
          <!-- 未完成訂單 Start -->
          <v-card
            v-if="!!reservedData"
            outlined
            rounded="lg"
            class="mb-5"
            :elevation="
              !($vuetify.breakpoint.xs || $vuetify.breakpoint.sm) ? 0 : 8
            "
          >
            <div class="d-flex pa-3">
              <v-img
                :src="orderThumbnail(reservedData)"
                v-if="orderThumbnail(reservedData)"
                width="100%"
                :max-width="$vuetify.breakpoint.xs ? 96 : 170"
                :max-height="$vuetify.breakpoint.xs ? 72 : 125"
                :aspect-ratio="4 / 3"
              >
                <template v-slot:placeholder>
                  <v-sheet
                    color="grey"
                    :width="$vuetify.breakpoint.xs ? 96 : 170"
                    :height="$vuetify.breakpoint.xs ? 72 : 125"
                  ></v-sheet>
                </template>
              </v-img>

              <div class="pl-4 order-overview">
                <div
                  class="font-weight-bold"
                  :class="{
                    'text-title': !$vuetify.breakpoint.xs,
                    'text-regular': $vuetify.breakpoint.xs
                  }"
                >
                  {{ reservedData.sessionName || "-" }}
                </div>
                <div
                  class="my-sm-2 font-weight-bold d-flex"
                  :class="{
                    'text-mini flex-column': $vuetify.breakpoint.xs
                  }"
                >
                  <div>{{ reservedData.sessionLocation || "-" }}</div>
                  <v-divider
                    vertical
                    class="mx-3"
                    v-if="!$vuetify.breakpoint.xs"
                  ></v-divider>
                  <div>{{ reservedData.sessionDateTime || "-" }}</div>
                </div>
                <div
                  class="status-list d-flex"
                  :class="{
                    'text-mini flex-column': $vuetify.breakpoint.xs
                  }"
                >
                  <span class="mr-sm-6 d-block d-sm-inline-block"
                    ><span>{{ $t("orderlist_ticket_count") }}</span
                    ><span class="ml-3">{{
                      reservedData.totalCount
                    }}</span></span
                  >
                  <span class="mr-sm-6 pr-sm-10 d-block d-sm-inline-block"
                    ><span>{{
                      $t(
                        !!reservedData.signupLottery
                          ? "registration_status"
                          : "orderlist_payment_status"
                      )
                    }}</span>
                    <span
                      :class="payStatusClass(reservedData.payStatus)"
                      class="font-weight-bold ml-3"
                    >
                      <span
                        role="button"
                        @click="finishReserveOrder"
                        class="purple--text"
                        >{{ $t("uncomplete_order") }}
                        <v-icon color="purple">mdi-share</v-icon>
                      </span>
                    </span>
                  </span>
                  <span class="mr-3 d-block d-sm-inline-block"
                    ><span>{{ $t("pickup_status") }}</span>
                    <span class="font-weight-bold ml-3">
                      {{
                        reservedData.shippingType === "post"
                          ? "-"
                          : reservedData.pickupStatus ||
                            $t("orderlist_no_pickup")
                      }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div
              class="bg-tranparent-yellow d-flex pa-3"
              :class="{
                'text-small': $vuetify.breakpoint.xs
              }"
            >
              <div :class="{ 'd-flex': !$vuetify.breakpoint.xs }">
                <div class="font-weight-bold">
                  {{ $t("orderlist_get_code")
                  }}<span class="ml-2 red--text">{{
                    reservedData.pickCode || "-"
                  }}</span>
                </div>
              </div>

              <v-spacer />
              <div
                @click="toggleDetail(reservedData)"
                class="cursor-pointer d-flex"
              >
                <div class="text-no-wrap align-self-center">
                  {{
                    $t(
                      !!reservedData.signupLottery
                        ? "registration_detail"
                        : "orderlist_order_detail"
                    )
                  }}
                </div>
                <v-icon>
                  {{
                    reservedData.expandDetail ? "mdi-menu-up" : "mdi-menu-down"
                  }}
                </v-icon>
              </div>
            </div>
            <div
              class="grey lighten-2 pa-3"
              :class="{
                'text-mini': $vuetify.breakpoint.xs
              }"
            >
              <div>
                {{ $t("orderlist_order_no")
                }}<span class="ml-2">#{{ reservedData.orderNum || "-" }}</span>
              </div>
              <div>
                {{ $t("orderlist_order_created_at")
                }}<span class="ml-2">{{ reservedData.orderTime }}</span>
              </div>
              <div>
                {{ $t("orderlist_order_total")
                }}<span class="ml-2 primary-1--text"
                  >NT.
                  {{
                    reservedData.total
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}</span
                >
              </div>
            </div>
            <v-expand-transition>
              <order-detail :order="reservedData" :isReserverd="true" />
            </v-expand-transition>
          </v-card>
          <!-- 未完成訂單 End -->
          <div
            class="text-center grey--text text-title"
            v-if="!orderList.length"
            :class="{ busy: internetBusy }"
          >
            {{ this.$t(internetBusy ? "order_143_error" : "orderlist_empty") }}
          </div>
          <template v-else>
            <v-card
              outlined
              rounded="lg"
              v-for="(order, index) in orderList"
              :key="order.orderNum"
              :class="{ 'mt-5': index !== 0 }"
            >
              <div class="d-flex pa-3">
                <v-img
                  :src="orderThumbnail(order)"
                  v-if="orderThumbnail(order)"
                  width="100%"
                  :max-width="$vuetify.breakpoint.xs ? 96 : 170"
                  :max-height="$vuetify.breakpoint.xs ? 72 : 125"
                  :aspect-ratio="4 / 3"
                >
                  <template v-slot:placeholder>
                    <v-sheet
                      color="grey"
                      :width="$vuetify.breakpoint.xs ? 96 : 170"
                      :height="$vuetify.breakpoint.xs ? 72 : 125"
                    ></v-sheet>
                  </template>
                </v-img>

                <div class="pl-4 order-overview">
                  <div
                    class="font-weight-bold"
                    :class="{
                      'text-title': !$vuetify.breakpoint.xs,
                      'text-regular': $vuetify.breakpoint.xs
                    }"
                  >
                    {{ order.sessionName || "-" }}
                  </div>
                  <div
                    class="my-sm-2 font-weight-bold d-flex"
                    :class="{
                      'text-mini flex-column': $vuetify.breakpoint.xs
                    }"
                  >
                    <div>{{ order.sessionLocation || "-" }}</div>
                    <v-divider
                      vertical
                      class="mx-3"
                      v-if="!$vuetify.breakpoint.xs"
                    ></v-divider>
                    <div>{{ order.sessionDateTime || "-" }}</div>
                  </div>
                  <div
                    class="status-list d-flex"
                    :class="{
                      'text-mini flex-column': $vuetify.breakpoint.xs
                    }"
                  >
                    <span class="mr-sm-6 d-block d-sm-inline-block"
                      ><span>{{ $t("orderlist_ticket_count") }}</span
                      ><span class="ml-3">{{ order.totalCount }}</span></span
                    >
                    <span class="mr-sm-6 pr-sm-10 d-block d-sm-inline-block"
                      ><span>{{
                        $t(
                          !!order.signupLottery
                            ? "registration_status"
                            : "orderlist_payment_status"
                        )
                      }}</span>
                      <span
                        :class="
                          payStatusClass(
                            order.payStatus,
                            order.doubleCheckingPayStatus
                          )
                        "
                        class="font-weight-bold ml-3"
                        >{{
                          order.doubleCheckingPayStatus
                            ? "待繳費"
                            : order.payStatus
                        }}
                      </span>
                    </span>
                    <span class="mr-3 d-flex d-sm-inline-flex align-center"
                      ><span>{{ $t("pickup_status") }}</span>
                      <span
                        class="font-weight-bold ml-3 d-inline-flex align-center"
                      >
                        {{
                          order.shippingType === "post"
                            ? "-"
                            : order.pickupStatus || $t("orderlist_no_pickup")
                        }}
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              <template v-if="order.transType && order.transType !== ''">
                <template
                  v-if="order.isShowPaymentBtn || order.isShowCCToCCRepayBtn"
                >
                  <div
                    class="d-flex py-5 px-3 py-md-5 justify-center payment-bg"
                  >
                    <span class="order-detail-content">
                      <template v-if="order.isShowPaymentBtn">
                        <v-btn
                          class="nextBtn"
                          @click="goPayment(order, false)"
                          depressed
                          >{{ $t("lottery_payment_act") }}</v-btn
                        >
                        <div
                          class="accent-blue--text mt-3 text-xs-mini text-small"
                          v-html="
                            $t('lottery_payment_deadline', {
                              lotteryDeadline: order.ccToCCDeadline
                            })
                          "
                        ></div>
                      </template>
                      <template v-else-if="order.isShowCCToCCRepayBtn">
                        <span class="order-detail-content">
                          <v-btn
                            color="yellow darken-1"
                            @click="goPayment(order, true)"
                            depressed
                            >{{ $t("lottery_payment_repay") }}</v-btn
                          >
                          <div
                            class="accent-blue--text mt-3 text-xs-mini text-small"
                            v-html="
                              $t('lottery_payment_deadline', {
                                lotteryDeadline: order.ccToCCDeadline
                              })
                            "
                          ></div>
                        </span>
                      </template>
                    </span>
                  </div>
                </template>
                <template
                  v-else-if="
                    (order.transType !== 'FREE' &&
                      order.payStatus === '待繳費') ||
                      (order.payStatus !== '已付款' &&
                        order.doubleCheckingPayStatus)
                  "
                >
                  <div
                    class="d-flex py-5 px-3 py-md-5 justify-center payment-bg"
                  >
                    <span class="order-detail-content">
                      <template
                        v-if="
                          (order.lotteryDeadline ||
                            order.ccToCCDeadline ||
                            order.doubleCheckingPayStatus) &&
                            order.transType !== 'ATM'
                        "
                      >
                        <v-btn color="yellow darken-1" disabled depressed>{{
                          $t("payment_confirm")
                        }}</v-btn>
                        <div
                          v-html="$t('orderlist_payment_confirm_info')"
                          class="mt-3 text-xs-small"
                        ></div>
                        <div
                          class="accent-blue--text mt-2 text-xs-mini text-small"
                          v-html="
                            $t('lottery_payment_deadline', {
                              lotteryDeadline: order.ccToCCDeadline
                            })
                          "
                        ></div>
                      </template>
                      <template v-else>
                        <div class="bank-info">
                          <div>
                            {{ $t("orderlist_bank_code") }}
                            <span class="order-detail-content">
                              {{ order.bankCode }}
                            </span>
                          </div>
                          <div>
                            {{ $t("orderlist_bank_account") }}
                            <span class="order-detail-content">
                              {{ order.atmAccount }}
                            </span>
                          </div>
                        </div>
                        <div
                          class="accent-blue--text mt-3 text-xs-mini text-small"
                          v-html="
                            $t('lottery_payment_deadline', {
                              lotteryDeadline: order.atmPaymentDeadline
                            })
                          "
                        ></div>
                      </template>
                    </span>
                  </div>
                </template>
              </template>
              <div
                class="bg-tranparent-yellow d-flex pa-3"
                :class="{
                  'text-small': $vuetify.breakpoint.xs
                }"
              >
                <div :class="{ 'd-flex': !$vuetify.breakpoint.xs }">
                  <div class="font-weight-bold">
                    {{ $t("orderlist_get_code")
                    }}<span class="ml-2 red--text">{{
                      order.pickCode || "-"
                    }}</span>
                  </div>
                </div>
                <v-spacer />
                <div
                  @click="toggleDetail(orderList[index])"
                  class="cursor-pointer d-flex primary-1--text"
                >
                  <div class="text-no-wrap font-weight-bold align-self-center">
                    {{
                      $t(
                        !!order.signupLottery
                          ? "registration_detail"
                          : "orderlist_order_detail"
                      )
                    }}
                  </div>
                  <v-icon color="primary-1">
                    {{ order.expandDetail ? "mdi-menu-up" : "mdi-menu-down" }}
                  </v-icon>
                </div>
              </div>
              <div
                class="grey lighten-2 pa-3"
                :class="{
                  'text-mini': $vuetify.breakpoint.xs
                }"
              >
                <div class="font-weight-bold">
                  {{ $t("orderlist_order_no")
                  }}<span class="ml-2">#{{ order.orderNum || "-" }}</span>
                </div>
                <div>
                  {{ $t("orderlist_order_created_at")
                  }}<span class="ml-2">{{ order.orderTime }}</span>
                </div>
                <div>
                  {{ $t("orderlist_order_total")
                  }}<span class="ml-2 primary-1--text"
                    >NT.
                    {{
                      order.total
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}</span
                  >
                </div>
              </div>
              <v-expand-transition>
                <order-detail
                  :order="order"
                  :index="index"
                  @editApplicant="
                    (ticket, i) => editApplicant(ticket, i, index)
                  "
                />
              </v-expand-transition>
            </v-card>
          </template>
        </template>
        <div class="text-center" v-else>
          <v-progress-circular
            indeterminate
            color="primary-1"
            size="25"
            width="2"
          ></v-progress-circular>
        </div>
      </v-card>
    </CustomRow>

    <ApplicantDialog
      v-if="showApplicantForm"
      :show="showApplicantForm"
      :isEdit="true"
      :selectedIdx="currentApplicantIdx"
      :tickets="applicantIdx > -1 ? orderList[applicantIdx].tickets : []"
      :orderNum="orderList[applicantIdx].orderNum"
      :applicants="orderList[applicantIdx].applicants"
      :applicant="currentApplicant"
      @close="closeApplicant"
      @beforeClose="beforeApplicantClose"
      @submit="submitApplicant"
    />
  </div>
</template>

<script>
import OM from "@/api/order-management";
import ApplicantDialog from "../../order/components/ApplicantDialog.vue";
import { mapActions } from "vuex";
import CC from "@/api/config-center";
import CustomPageHeaderVue from "@/components/CustomPageHeader.vue";
import { CurrentReservedMixins } from "@/shared/mixins";
import OrderDetail from "../components/OrderDetail.vue";

export default {
  mixins: [CurrentReservedMixins],
  components: {
    ApplicantDialog,
    CustomPageHeaderVue,
    OrderDetail
  },
  data() {
    const dt = new Date();
    const timeString = `${dt.getFullYear()}/${dt.getMonth() +
      1}/${dt.getDate()} ${dt.getHours()}:${dt.getMinutes()}`;
    return {
      contentHeight: window.innerHeight - 420,
      showApplicantForm: false,
      currentApplicant: null,
      currentApplicantIdx: -1,
      applicantIdx: -1,
      orderList: [],
      internetBusy: false,
      loadingFinished: false,
      reservedData: null
    };
  },
  metaInfo() {
    return {
      title: `${this.$t("orderlist_title")} - ${this.$t("app_name")}`,
      meta: [
        {
          property: "og:title",
          content: `${this.$t("orderlist_title")} - ${this.$t("app_name")}`,
          vmid: "og:title"
        },
        {
          property: "og:url",
          content: window.location.href,
          vmid: "og:url"
        }
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: `${this.$t("orderlist_title")} - ${this.$t("app_name")}`,
            url: window.location.href
          }
        }
      ]
    };
  },
  methods: {
    ...mapActions({
      setCurrentOrder: "order/setCurrentOrder",
      setCampaign: "event/setCampaign",
      setSession: "session/setSession",
      setAreaAssignment: "order/setAreaAssignment",
      showDialog: "dialog/show",
      setTimer: "order/setTimer",
      reserveTicket: "order/reserveTicket",
      resetOrderState: "order/resetOrderState",
      setPopState: "order/setPopState",
      setPageData: "order/setPageData"
    }),
    async finishReserveOrder() {
      this.$store.dispatch("setOverlayLoading", true);
      const {
        hasReservedOrder,
        currentReserved,
        reservedEventId,
        reservedSessionId
      } = await this.checkReservedOrder();

      if (hasReservedOrder) {
        this.$router
          .push({
            name: "Order2",
            params: {
              eventId: reservedEventId,
              sessionId: reservedSessionId
            }
          })
          .catch(() => {});
        this.$store.dispatch("setOverlayLoading", false);
      }
    },
    toggleDetail(order) {
      order.expandDetail = !order.expandDetail;
      // 我的訂單_{活動名稱}_展開明細
    },
    goPayment(order, repay) {
      this.setCurrentOrder(order);
      this.$router
        .push({
          name: "OrderedPayment",
          params: { orderNum: order.orderNum },
          query: { repay }
        })
        .catch(() => {});
    },
    transTypeText(type) {
      let str = "";
      switch (type) {
        case "ATM":
          str = this.$t("orderlist_virtual_account");
          break;
        case "CC":
          str = this.$t("orderlist_card_payment_one_time");
          break;
        default:
          str = "-";
      }
      return str;
    },
    async editApplicant(ticket, i, orderIdx) {
      this.currentApplicant = {
        ticketName: ticket.productName,
        index: i,
        displayIndex: `${i + 1 < 10 ? "0" : ""}${i + 1}`,
        ...ticket.applicant
      };
      this.currentApplicantIdx = i;
      this.applicantIdx = orderIdx;

      let [{ data: sessionInfo }, getInfosErr] = await CC.getInfos({
        sessionId: [this.orderList[orderIdx].sessionId]
      });

      if (sessionInfo.errCode == "00") {
        this.setSession({
          ...sessionInfo.result.session[0]
        });
        this.showApplicantForm = true;
      }
    },
    closeApplicant() {
      this.showApplicantForm = false;
    },
    async submitApplicant(app) {
      let appli = { ...app.data };
      delete appli.displayIndex;
      let params = {
        orderNum: this.orderList[this.applicantIdx].orderNum,
        applicants: [appli]
      };
      const { data: getCCresponse } = await OM.updateApplicant(params);
      if (getCCresponse.errCode === "00") {
        this.orderList[this.applicantIdx].tickets[
          appli.index
        ].applicant = appli;
        this.currentApplicant = null;
        this.showApplicantForm = false;
      } else {
        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
              <img
                src="/image/ic-warning@3x.png"
                alt=""
                style="width:80px"
              />
              <div class="mt-5">${this.$t(
                getCCresponse.errCode === "101"
                  ? "error_with_no_outstanding_order"
                  : getCCresponse.errCode === "144"
                  ? "applicant_144_err"
                  : "duplicate_id_number"
              )}</div>
            </div>`
        });
      }
    },
    beforeApplicantClose(applicant) {
      const $this = this;
      this.showDialog({
        title: this.$t("orderlist_applicant_dialog_title"),
        content: this.$t("orderlist_applicant_dialog_content"),
        buttons: [
          {
            text: this.$t("layout_notification_cancel"),
            style: {
              block: true,
              outlined: true,
              color: "primary"
            },
            action() {
              setTimeout(() => {
                $this.showApplicantForm = true;
              }, 200);
            }
          },
          {
            text: this.$t("layout_notification_confirm"),
            style: {
              depressed: true,
              block: true,
              outlined: false,
              color: "primary"
            },
            action() {
              $this.showApplicantForm = false;
            }
          }
        ]
      });
    },
    orderThumbnail(order) {
      if (order.orderEventBigThumbnail || order.orderEventSmallThumbnail) {
        if (this.$vuetify.breakpoint.xs) return order.orderEventSmallThumbnail;
        else return order.orderEventBigThumbnail;
      } else return false;
    },
    shippingAddr(order) {
      if (
        order.shippingAddress.county &&
        order.shippingAddress.district &&
        order.shippingAddress.address
      ) {
        return (
          order.shippingAddress.county +
          order.shippingAddress.district +
          order.shippingAddress.address
        );
      } else return "-";
    },
    payStatusClass(payStatus, doubleCheckingPayStatus) {
      let str = "";
      if (doubleCheckingPayStatus) str = "waitingPay";
      else
        switch (payStatus) {
          case "付款失敗":
            str = "paidFailed";
            break;
          case "待繳費":
            str = "waitingPay";
            break;
          case "已登記":
          case "已付款":
            str = "hasPaid";
            break;
          default:
            return "";
        }
      return str;
    }
  },
  beforeMount() {
    this.resetOrderState();
    this.setPopState(false);
    this.setPageData(null);
  },
  async mounted() {
    const { data } = await OM.getAllPurchases();

    if (data.errCode == "143") {
      this.internetBusy = true;
    }

    if (data.errCode == "00") {
      if (data.reservedData && data.reservedData.length) {
        this.reservedData = {
          ...data.reservedData[0],
          expandDetail: false
        };
      }
      this.orderList = data.data.map((order, i) => ({
        ...order,
        tickets: order.tickets.map(t => {
          if (t.applicant) {
            t.applicant = {
              ...t.applicant
            };
          }
          if (order.voidTicketInfo.length) {
            let voidInfo = "";
            order.voidTicketInfo.forEach(v => {
              if (v.tickets) {
                v.tickets.forEach(voidticket => {
                  if (voidticket.ticketNum === t.ticketNum) {
                    t.voidTicket = order.signupLottery
                      ? this.$t("cancellation_success")
                      : this.$t("refund_success");
                  }
                });
              }
            });
          }
          return t;
        }),
        expandDetail: i === 0
      }));

      this.$store.dispatch("setOverlayLoading", false);
    }

    this.loadingFinished = true;
    this.$gtm.trackView(`我的訂單`, this.$route.path);
  }
};
</script>

<style lang="scss" scoped>
.cusPadding {
  padding: 40px 100px;

  @media screen and (max-width: 600px) {
    padding: 20px 15px;
  }

  @media only screen and (min-width: 600px) and (max-width: 960px) {
    padding: 40px;
  }
}

.paidFailed {
  color: #ff0909;
}

.order-overview {
  flex: 1;
  flex-grow: 1;
  align-content: center;

  .status-list {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    > span {
      display: inline-block;
      padding-right: 8px;
    }
  }
}

.waitingPay {
  color: #ff5b09;
}

.hasPaid {
  color: #28bd92;
}

.v-sheet--outlined {
  box-shadow: none !important;
  border: thin solid $grey-lighten-1;
}

.busy {
  text-align: center;
  position: absolute;
  margin: auto;
  height: 40px;
  display: block;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.bg-transparent {
  background: transparent;
}

.payment-bg {
  background: rgba(241, 249, 254, 1);

  > .order-detail-content {
    width: 100%;
    max-width: 600px;
    text-align: center;
  }
}

@media screen and (min-width: 600px) {
  .payment-confirm-info br {
    display: inline;
  }
}

.bank-info {
  padding: 12px 0;
  border: 1px solid rgba(213, 213, 213, 1);
  border-radius: 4px;
  background: white;
  justify-items: flex-start;
  width: 100%;
  max-width: 600px;

  > div {
    padding: 0 20px;

    .order-detail-content {
      padding-left: 12px;
    }
  }
}
</style>
